export default "__VITE_ASSET__CNU75eYF__"